exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".styles__Tabs___3HObr ul{align-items:flex-start;flex-wrap:wrap}.styles__Tabs___3HObr li{color:#0a6eb4}", ""]);

// Exports
exports.locals = {
	"Tabs": "styles__Tabs___3HObr"
};